module.exports = __webpack_public_path__ + "img/final-portfolio.64c1362a.svg";